import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { doc, deleteDoc } from 'firebase/firestore';
import { db } from '../firebase';
import ModalBasic from '../components/ModalBasic';
import { TrashIcon } from '@heroicons/react/20/solid';

export default function DeleteCampaign({ campaignId }) {
  const [modalOpen, setModalOpen] = useState(false);
  const navigate = useNavigate();

  const handleDelete = async () => {
    const docRef = doc(db, "campaign", campaignId);
    try {
      await deleteDoc(docRef);
      navigate("/studio/dashboard");
    } catch (error) {
      console.error("Error deleting campaign:", error);
    }
  };

  // Helper function to open modal with delay
  const openDeleteModal = () => {
    // Add 300ms delay before showing modal
    setTimeout(() => {
      setModalOpen(true);
    }, 300);
  };

  return (
    <>
      <div className="mt-6">
        <button
          onClick={openDeleteModal}
          className="w-full flex items-center justify-center px-4 py-2 rounded-md shadow-sm text-sm font-bold tracking-wide transition-all duration-200"
          style={{
            background: 'rgba(231, 76, 60, 0.1)',
            border: '1px solid rgba(231, 76, 60, 0.4)',
            color: '#E74C3C',
            fontFamily: '"Share Tech Mono", monospace'
          }}
          onMouseEnter={(e) => {
            e.target.style.background = 'rgba(231, 76, 60, 0.2)';
            e.target.style.border = '1px solid rgba(231, 76, 60, 0.6)';
          }}
          onMouseLeave={(e) => {
            e.target.style.background = 'rgba(231, 76, 60, 0.1)';
            e.target.style.border = '1px solid rgba(231, 76, 60, 0.4)';
          }}
        >
          <TrashIcon className="h-4 w-4 mr-2" />
          DELETE CAMPAIGN
        </button>
      </div>

      <ModalBasic
        id="delete-campaign-modal"
        title="Delete Campaign"
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
      >
        <div className="p-6">
          <div className="space-y-6">
            <p className="text-sm" style={{ color: '#ECF0F1' }}>
              Are you sure you want to delete this campaign? This action cannot be undone.
            </p>
            <div className="flex flex-wrap justify-end space-x-2">
              <button
                className="px-4 py-2 text-sm font-bold tracking-wide transition-all duration-200 rounded-md"
                style={{
                  background: 'rgba(52, 73, 94, 0.8)',
                  border: '1px solid rgba(149, 165, 166, 0.4)',
                  color: '#ECF0F1',
                  fontFamily: '"Share Tech Mono", monospace'
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = 'rgba(149, 165, 166, 0.3)';
                  e.target.style.border = '1px solid rgba(149, 165, 166, 0.6)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = 'rgba(52, 73, 94, 0.8)';
                  e.target.style.border = '1px solid rgba(149, 165, 166, 0.4)';
                }}
                onClick={() => setModalOpen(false)}
              >
                CANCEL
              </button>
              <button
                className="px-4 py-2 text-sm font-bold tracking-wide transition-all duration-200 rounded-md"
                style={{
                  background: 'linear-gradient(135deg, #E74C3C, #C0392B)',
                  border: '1px solid rgba(231, 76, 60, 0.4)',
                  color: '#FFFFFF',
                  fontFamily: '"Share Tech Mono", monospace',
                  textShadow: '1px 1px 0px #A93226'
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = 'linear-gradient(135deg, #C0392B, #A93226)';
                  e.target.style.border = '1px solid rgba(231, 76, 60, 0.6)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = 'linear-gradient(135deg, #E74C3C, #C0392B)';
                  e.target.style.border = '1px solid rgba(231, 76, 60, 0.4)';
                }}
                onClick={() => {
                  handleDelete();
                  setModalOpen(false);
                }}
              >
                DELETE
              </button>
            </div>
          </div>
        </div>
      </ModalBasic>
    </>
  );
}
